import React, {useMemo, useRef} from 'react';
import {OverlayPanel} from "primereact/overlaypanel";
import {ListBox} from "primereact/listbox";
import {InputText} from "primereact/inputtext";
import Icon from "../../../system/components/icon";
import {useTranslate} from "../../../system/useTranslate";

function MultiSelectProjects({
                                 value = [],
                                 onChange,
                                 options = []
                             }) {
    const overlayRef = useRef(null);
    const translate = useTranslate();

    const safeOptions = useMemo(() => (
        Array.isArray(options) ? options : []
    ), [options]);

    const selectedIds = useMemo(() => (
        (Array.isArray(value) ? value : [])
            .map(project => project?.id)
            .filter(Boolean)
    ), [value]);

    const selectedProjects = useMemo(() => (
        safeOptions.filter(project => selectedIds.includes(project.id))
    ), [safeOptions, selectedIds]);

    const itemTemplate = (option) => {
        return (
            <div className="flex align-items-center justify-content-between w-full">
                <div className="flex align-items-center gap-2">
                    {option?.color_icon?.icon ? (
                        <Icon
                            icon={option.color_icon.icon}
                            className={`text-${option?.color_icon?.color || "primary"}`}
                        />
                    ) : (
                        <Icon icon="mi mi:folder" />
                    )}
                    <span className="text-xs">{option?.title}</span>
                </div>
            </div>
        );
    };

    return (
        <div className="flex align-items-center gap-1 flex-wrap">
            <div
                className="cursor-pointer flex align-items-center gap-1 text-xs p-1"
                onClick={(e) => overlayRef.current?.toggle(e)}
            >
                <Icon icon="mi mi:add" className="text-sm"/>
                <span>{translate("project")}</span>
            </div>

            {selectedProjects.map((project) => (
                <div
                    key={project.id}
                    className="w-fit flex align-items-center gap-1 text-xs p-1 px-2 surface-100 border-round-2xl"
                >
                    <Icon icon="mi mi:circle" className="text-3xs"/>
                    <span>{project.title}</span>
                </div>
            ))}

            <OverlayPanel
                ref={overlayRef}
                pt={{
                    root: () => ({
                        className: "p-0 rtl w-15rem project-overlay"
                    }),
                    content: () => ({
                        className: "p-0"
                    })
                }}
            >
                <ListBox
                    className="w-15rem border-none"
                    multiple
                    checkbox
                    filter
                    options={safeOptions}
                    value={selectedIds}
                    optionLabel="title"
                    optionValue="id"
                    itemTemplate={itemTemplate}
                    filterBy="title"
                    pt={{
                        item: () => ({
                            className: "p-2"
                        }),
                        header: () => ({
                            className: "p-1 border-none shadow-none"
                        })
                    }}
                    filterTemplate={(options) => (
                        <div className="p-2">
                            <InputText
                                className="p-2 w-full text-xs"
                                placeholder={translate("search")}
                                onChange={options.filterOptions.filter}
                            />
                        </div>
                    )}
                    onChange={(e) => {
                        const nextIds = e.value ?? [];

                        const nextProjects = safeOptions.filter(project =>
                            nextIds.includes(project.id)
                        );

                        onChange?.(nextProjects);
                    }}
                />
            </OverlayPanel>
        </div>
    );
}

export default MultiSelectProjects;
